import { defineMessages } from 'react-intl';

import { TimelineCategory } from './types';

export const timelineCategoryMessages = defineMessages<TimelineCategory>({
  all: {
    id: 'global.all',
    defaultMessage: 'All',
  },
  cbct: {
    id: 'patientProfile.timeline.category.cbct',
    defaultMessage: 'CBCT',
  },
  '2d': {
    id: 'patientProfile.timeline.category.2d',
    defaultMessage: '2D',
  },
  '3d': {
    id: 'patientProfile.timeline.category.3d',
    defaultMessage: '3D',
  },
  transcripts: {
    id: 'patientRecordings.title',
    defaultMessage: 'Recordings',
  },
  photos: {
    id: 'patientProfile.timeline.category.photos',
    defaultMessage: 'Photos',
  },
});
